var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuriname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95418 31.0461 -0.00012207 20.0004 -0.00012207C8.95472 -0.00012207 0.000411987 8.95418 0.000411987 19.9999C0.000411987 31.0456 8.95472 39.9999 20.0004 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.756 13.0434H1.24395C0.440124 15.2101 4.57764e-05 17.5535 4.57764e-05 19.9999C4.57764e-05 22.4463 0.440124 24.7898 1.24395 26.9564H38.7561C39.56 24.7898 40 22.4463 40 19.9999C40 17.5535 39.56 15.2101 38.756 13.0434Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.058 39.9998C26.9082 39.9998 32.9532 36.5551 36.5577 31.3041H3.5584C7.16293 36.5551 13.2078 39.9998 20.058 39.9998Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.058 0C26.9082 0 32.9532 3.44469 36.5577 8.69562H3.5584C7.16293 3.44469 13.2078 0 20.058 0V0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.0434L21.7267 18.3575H27.3146L22.794 21.6422L24.5208 26.9564L20.0001 23.6721L15.4794 26.9564L17.2062 21.6422L12.6855 18.3575H18.2734L20.0001 13.0434Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuriname);
export default __webpack_public_path__ + "static/media/suriname.da80f166e8aede8e696e00c4c2471a05.svg";
export { ForwardRef as ReactComponent };